import CustomersPage from './customers-page'

export default CustomersPage
